import { Container } from "@fideus-ui/core";
import { createFileRoute } from "@tanstack/react-router";
import { DatevEntryTab } from "../../../../companies/masterData/DatevEntryTab";

export const Route = createFileRoute(
  "/firmen/$companyId/stammdaten/datev-eintragen"
)({
  loader: async ({ context: { queryClient, trpc }, params: { companyId } }) => {
    void queryClient.ensureQueryData(
      trpc.companies.getCompany.queryOptions({ companyId })
    );
    void queryClient.ensureQueryData(
      trpc.companies.getCompanyAddress.queryOptions({ companyId })
    );
    void queryClient.ensureQueryData(
      trpc.companies.getCommercialRegisterEntry.queryOptions({ companyId })
    );
    void queryClient.ensureQueryData(
      trpc.clients.listUsersWithCompanyAccess.queryOptions({ companyId })
    );
    void queryClient.ensureQueryData(
      trpc.documents.listDocumentsByCompanyId.queryOptions({ companyId })
    );
  },
  component: DatevEintragenRoute,
});

function DatevEintragenRoute() {
  const { companyId } = Route.useParams();
  return (
    <Container>
      <DatevEntryTab companyId={companyId} />
    </Container>
  );
}
